import { useEffect, useState } from "react";
import axios from "axios";

import { useAuth0 } from "../react-auth0-spa";
import { API_URL } from "../../constants/constants";

export const usePostDestinatarios = () => {
  const [body, setBody] = useState(null);
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { getTokenSilently, user } = useAuth0();

  useEffect(() => {
    if (!body) return;
    const postDestinatario = async () => {
      setIsError(false);
      setIsLoading(true);
      try {
        const { nombre, correo, telefono, empresa = "Dr. Envio" } = body;
        const t = await getTokenSilently();
        const r = await axios.post(
          API_URL + `/destinatarios/${user.sub}`,
          {
            nombre,
            correo,
            telefono,
            empresa
          },
          {
            headers: {
              // "Access-Control-Allow-Origin": "*",
              Authorization: `Bearer ${t}`
            }
          }
        );
        setData(r.data);
      } catch (error) {
        console.log(error);
        setIsError(true);
      }
      setIsLoading(false);
    };
    postDestinatario();
  }, [body,getTokenSilently,user.sub]);

  return [{ data, isLoading, isError }, setBody];
  };

export default usePostDestinatarios;
